import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';
import VueSession from 'vue-session';
import api from '../../utils/api';

const options = {
  persist: true
};

Vue.use(Vuex);
Vue.use(VueSession, options);

const state = {
  company: {},
  facilities: {},
  singleFacility: {},
  // devices: {},
  companyDetails: {},
  facilityDetails: [],
  tankDetails: [],
  singleTankData: {},
  gpsAddress: {},
  staticData: {},
  users: [],
  logs: [],
  sortedFacility: {}
};

const getters = {
  getCompany: state => state.company,
  getFacilities: state => state.facilities,
  getSingleFacility: state => state.singleFacility,
  // getDevices: state => state.devices,
  getCompanyDetails: state => state.companyDetails,
  getFacilityDetails: state => state.facilityDetails,
  getSortedFacility: state => state.sortedFacility,
  getTankDetails: state => state.tankDetails,
  getSingleTankData: state => state.singleTankData,
  getGpsAddress: state => state.gpsAddress,
  getStaticData: state => state.staticData,
  getUsers: state => state.users,
  getLogs: state => state.logs
};

const mutations = {
  setCompanyDetails: (state, data) => {
    state.companyDetails = data;
  },
  setCompany: (state, data) => {
    state.company = data;
  },
  setFacilities: (state, data) => {
    state.facilities = data;
  },
  setSingleFacility: (state, data) => {
    state.singleFacility = data;
  },
  // setDevices: (state, data) => {
  //   state.devices = data;
  // },
  setFacilityDetails: (state, data) => {
    const sortedFacility = { tanker: [], station: [], isolated: [] };
    state.facilityDetails = data;
    for (let i = 0; i < data.length; i++) {
      data[i].index = i;
      if (data[i].facility_type === 'tanker') {
        sortedFacility.tanker.push(data[i]);
      } else if (data[i].facility_type === 'station') {
        sortedFacility.station.push(data[i]);
      } else if (data[i].facility_type === 'isolated') {
        sortedFacility.isolated.push(data[i]);
      }
    }
    state.sortedFacility = sortedFacility;
  },
  setTankDetails: (state, data) => {
    state.tankDetails = data;
  },
  setSingleTankData: (state, data) => {
    state.singleTankData = data;
  },
  setGpsAddress(state, data) {
    state.gpsAddress[data.latlng] = data.address;
  },
  setStaticData: (state, data) => {
    state.staticData = data;
  },
  resetStore: (state, data) => {
    state.tankDetails = data;
    state.singleTankData = data;
  },
  setUsers: (state, data) => {
    state.users = data;
  },
  setLogs: (state, data) => {
    state.logs = data;
  }
};

const actions = {
  fetchCompany: async({ commit }) => {
    // commit('resetReq', null, { root: true });
    commit('reqInit', null, { root: true });
    try {
      const response = await api.get('/api/v1/company');
      if (response.status === 200) {
        commit('setCompany', response.data.data);
        commit('reqSuccess', null, { root: true });
        return Promise.resolve(true);
      }
      commit('reqError', null, { root: true });
    } catch (error) {
      commit('reqError', null, { root: true });
      return Promise.reject(error);
    }
  },
  fetchFacilities: async({ commit }, data) => {
    // commit('resetReq', null, { root: true });
    const { id } = data;
    commit('reqInit', null, { root: true });
    try {
      const response = await api.get(`/api/v1/company/${id}/facility`);
      if (response.status === 200) {
        commit('setFacilities', response.data.data);
        commit('reqSuccess', null, { root: true });
        return Promise.resolve(true);
      }
      commit('reqError', null, { root: true });
    } catch (error) {
      commit('reqError', null, { root: true });
      return Promise.reject(error);
    }
  },
  fetchSingleFacility: async({ commit }, data) => {
    // commit('resetReq', null, { root: true });
    const { id, facility_id } = data;
    commit('reqInit', null, { root: true });
    try {
      const response = await api.get(`/api/v1/company/${id}/facility/${facility_id}`);
      if (response.status === 200) {
        commit('setSingleFacility', response.data.data);
        commit('reqSuccess', null, { root: true });
        return Promise.resolve(true);
      }
      commit('reqError', null, { root: true });
    } catch (error) {
      commit('reqError', null, { root: true });
      return Promise.reject(error);
    }
  },
  // fetchDevices: async({ commit }, data) => {
  //   // commit('resetReq', null, { root: true });
  //   const { company_id, facility_id, tank_id } = data;
  //   commit('reqInit', null, { root: true });
  //   try {
  //     const response = await api.get(`/api/v1/company/${company_id}/facility/${facility_id}/tank/${tank_id}/device`);
  //     if (response.status === 200) {
  //       // commit('resetAppFormData');
  //       commit('setDevices', response.data.data);
  //       commit('reqSuccess', null, { root: true });
  //       return Promise.resolve(true);
  //     }
  //     commit('reqError', null, { root: true });
  //   } catch (error) {
  //     commit('reqError', null, { root: true });
  //     return Promise.reject(error);
  //   }
  // },
  fetchCompanyDetails: async({ commit }, company_id) => {
    // commit('resetReq', null, { root: true });
    commit('reqInit', null, { root: true });
    try {
      const response = await api.get(`/api/v1/company/${company_id}`);
      if (response.status === 200) {
        commit('setCompanyDetails', response.data.data);
        commit('reqSuccess', null, { root: true });
        return Promise.resolve(true);
      }
      commit('reqError', null, { root: true });
    } catch (error) {
      commit('reqError', null, { root: true });
      return Promise.reject(error);
    }
  },
  fetchFacilityDetails: async({ commit }, company_id) => {
    // commit('resetReq', null, { root: true });
    commit('reqInit', null, { root: true });
    try {
      const response = await api.get(`/api/v1/company/${company_id}/facility`);
      if (response.status === 200) {
        // commit('resetAppFormData');
        commit('setFacilityDetails', response.data.data);
        commit('reqSuccess', null, { root: true });
        return Promise.resolve(true);
      }
      commit('reqError', null, { root: true });
    } catch (error) {
      commit('reqError', null, { root: true });
      return Promise.reject(error);
    }
  },
  fetchTankDetails: async({ commit }, data) => {
    // commit('resetReq', null, { root: true });
    const { company_id, facility_id } = data;
    commit('reqInit', null, { root: true });
    try {
      const response = await api.get(`/api/v1/company/${company_id}/facility/${facility_id}/tank`);
      if (response.status === 200) {
        // commit('resetAppFormData');
        commit('setTankDetails', response.data.data);
        commit('reqSuccess', null, { root: true });
        return Promise.resolve(true);
      }
      commit('reqError', null, { root: true });
    } catch (error) {
      commit('reqError', null, { root: true });
      return Promise.reject(error);
    }
  },
  fetchSingleTankData: async({ commit }, data) => {
    // commit('resetReq', null, { root: true });
    const {
      company_id, facility_id, tank_id, on
    } = data;
    commit('reqInit', null, { root: true });
    try {
      const response = on ?
        await api.get(
          `/api/v1/company/${company_id}/facility/${facility_id}/tank/${tank_id}/tank-data/daily?on=${on}`
        ) :
        await api.get(
          `/api/v1/company/${company_id}/facility/${facility_id}/tank/${tank_id}/tank-data/daily`
        );
      if (response.status === 200) {
        // commit('resetAppFormData');
        commit('setSingleTankData', response.data.data.data);
        commit('setStaticData', response.data.data.staticData);
        commit('reqSuccess', null, { root: true });
        return Promise.resolve(true);
      }
      commit('reqError', null, { root: true });
    } catch (error) {
      commit('reqError', null, { root: true });
      return Promise.reject(error);
    }
  },
  storeGpsAddress({ commit }, latlng) {
    axios.get(`https://maps.googleapis.com/maps/api/geocode/json?latlng=${latlng}&key=${process.env.VUE_APP_MAP_KEY}`).then(
      response => {
        if (response.status === 200) {
          const realAddress = response.data.results[0].formatted_address;
          commit('setGpsAddress', { latlng, address: realAddress });
        }
      }
    );
  },
  fetchUsers: async({ commit }, data) => {
    const { company_id } = data;
    commit('reqInit', null, { root: true });
    try {
      const response = await api.get(`/api/v1/company/${company_id}/user`);
      if (response.status === 200) {
        commit('setUsers', response.data.data);
        commit('reqSuccess', null, { root: true });
        return Promise.resolve(true);
      }
      commit('reqError', null, { root: true });
    } catch (error) {
      commit('reqError', null, { root: true });
      return Promise.reject(error);
    }
  },
  deleteUser: async({ commit, dispatch }, data) => {
    const { company_id, user_id } = data;
    commit('reqInit', null, { root: true });
    try {
      const response = await api.delete(`/api/v1/company/${company_id}/user/${user_id}`);
      if (response.status === 200) {
        dispatch('fetchUsers');
        commit('reqSuccess', null, { root: true });
        return Promise.resolve(true);
      }
      commit('reqError', null, { root: true });
    } catch (error) {
      commit('reqError', null, { root: true });
      return Promise.reject(error);
    }
  },
  fetchLogs: async({ commit }, data) => {
    const { company_id } = data;
    commit('reqInit', null, { root: true });
    try {
      const response = await api.get(`/api/v1/company/${company_id}/log`);
      if (response.status === 200) {
        commit('setLogs', response.data.data);
        commit('reqSuccess', null, { root: true });
        return Promise.resolve(true);
      }
      commit('reqError', null, { root: true });
    } catch (error) {
      commit('reqError', null, { root: true });
      return Promise.reject(error);
    }
  },
  addNewUser: ({ commit, dispatch }, data) => {
    commit('reqInit', null, { root: true });
    const { companyId } = data;
    api
      .post(`/api/v1/company/${companyId}/user`, data)
      .then(response => {
        if (response.status === 200) {
          // commit('fetchUsers');
          commit('reqSuccess', null, { root: true });
          dispatch('fetchUsers');
          return true;
        }
        commit('reqError', null, { root: true });

        return false;
      })
      .catch(error => {
        commit('reqError', null, { root: true });
        return error;
      });
    return true;
  },
  clearStore: ({ commit }) => {
    commit('resetStore', null);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};
